import {
  Component,
  ElementRef,
  EventEmitter,
  HostListener,
  Input,
  Output,
  QueryList,
  ViewChild,
  ViewChildren
} from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import moment from 'moment';
import { CustomToastsService } from '../../../Services/custom-toasts.service';
import { DateRangeModel } from 'src/app/Models/ApplicationModels';

@Component({
  selector: 'app-daterange',
  templateUrl: './daterange.component.html',
  styleUrls: ['./daterange.component.css']
})
export class DaterangeComponent {
  @Input() showAll: boolean = true;
  @Output() dateRangeSelected = new EventEmitter<DateRangeModel>();
  @Input() hideSpecifyPeriod: boolean = false;
  @Input() isSummaryReport: boolean = false;
  @Input() isTaxReport: boolean = false;
  months: string[] = [
    'Jan',
    'Feb',
    'Mar',
    'Apr',
    'May',
    'Jun',
    'Jul',
    'Aug',
    'Sep',
    'Oct',
    'Nov',
    'Dec'
  ];
  hours: number[] = [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12];
  AmPms: string[] = ['AM', 'PM'];
  quarter: string = 'Q1';
  years: number[] = [];
  quarters: string[] = ['Q1', 'Q2', 'Q3', 'Q4'];
  days: number[] = [];
  selecedDay!: string;
  selectedMonth!: string;
  selectedYear!: string;
  Date!: string;
  altmsg: boolean = false;
  dateRangeModel = new DateRangeModel();
  fromDate: string = moment().startOf('hour').format('MMM D YYYY, h:mm A');
  toDate: string = moment().format('MMM D YYYY, h:mm A');
  bootstrap: any;
  isDropdownOpen = false;
  minDate: Date = new Date();
  isDatePickerOpen = false; // Your flag to check if the date picker is open
  countOfEvent: any = 1;
  constructor(
    private route: ActivatedRoute,
    private toastr: CustomToastsService
  ) {}
  @ViewChildren('hourMonthItem') hourMonthItems!: QueryList<any>;
  @ViewChildren('hourDayItem') hourDayItems!: QueryList<any>;
  @ViewChildren('hourYearItem') hourYearItems!: QueryList<any>;
  @ViewChildren('hourHourItem') hourHourItems!: QueryList<any>;
  @ViewChildren('dayMonthItem') dayMonthItems!: QueryList<ElementRef>;
  @ViewChildren('dayDayItem') dayDayItems!: QueryList<ElementRef>;
  @ViewChildren('dayYearItem') dayYearItems!: QueryList<ElementRef>;
  @ViewChildren('monthMonthItem') monthMonthItems!: QueryList<ElementRef>;
  @ViewChildren('monthYearItem') monthYearItems!: QueryList<ElementRef>;
  @ViewChildren('monthDayItem') monthDayItems!: QueryList<ElementRef>;
  @ViewChildren('weekMonthItem') weekMonthItems!: QueryList<ElementRef>;
  @ViewChildren('weekYearItem') weekYearItems!: QueryList<ElementRef>;
  @ViewChildren('weekDayItem') weekDayItems!: QueryList<ElementRef>;
  @ViewChildren('yearQuarterItem') yearQuarterItems!: QueryList<ElementRef>;
  @ViewChildren('yearYearItem') yearYearItems!: QueryList<ElementRef>;
  @ViewChild('specificArea') specificArea!: ElementRef;
  @ViewChild('dropdownMenu') dropdownMenu!: ElementRef;
  @ViewChild('hoursOfDay') hoursOfDay!: ElementRef;
  @ViewChild('DayActive') DayActive!: ElementRef;
  ngOnInit() {
    this.populateYears();
    this.populateDays();
    this.setStartingDate();
    this.getQuarter();
    this.getRoutID();
    this.dateRangeModel.isDateRangeSelected = false;
    this.selectPeriodType(1);
  }
  toggleDropdown() {
    this.hideSpecifyPeriod;
    if (this.hideSpecifyPeriod) {
      //this.tabindex  = 1

      const button = document.getElementById('pills-contact1-tab');
      if (button) {
        button.click(); // Programmatically clicks the button
      } else {
        console.error('Button not found!');
      }
    }
    setTimeout(() => {
      this.isDropdownOpen = !this.isDropdownOpen;
    }, 0);
  }

  stopPropagationIt() {
    setTimeout(() => {
      this.isDropdownOpen = true;
    }, 0);
  }
  ngAfterViewInit() {
    this.scrollToSelectedMonth();
  }

  scrollToSelectedMonth() {
    const startingDatehour = new Date(
      this.dateRangeModel.hourModel.startingDate
    );
    const Monthhour = startingDatehour.toLocaleDateString('default', {
      month: 'short'
    });
    const startingDatedayweek = new Date(
      this.dateRangeModel.weekModel.startingDate
    );
    const Monthweek = startingDatedayweek.toLocaleDateString('default', {
      month: 'short'
    });
    const startingDateweday = new Date(
      this.dateRangeModel.dayModel.startingDate
    );
    const Monthday = startingDateweday.toLocaleDateString('default', {
      month: 'short'
    });
    const startingDatemonth = new Date(
      this.dateRangeModel.monthModel.startingDate
    );
    const Monthmonth = startingDatemonth.toLocaleDateString('default', {
      month: 'short'
    });

    setTimeout(() => {
      this.hourMonthItems.forEach((element, index) => {
        if (element.nativeElement.textContent.trim() === Monthhour) {
          element.nativeElement.scrollIntoView({
            behavior: 'smooth',
            block: 'nearest'
          });
        }
      });
    });
    setTimeout(() => {
      this.dayMonthItems.forEach((element, index) => {
        if (element.nativeElement.textContent.trim() === Monthday) {
          element.nativeElement.scrollIntoView({
            behavior: 'smooth',
            block: 'nearest'
          });
        }
      });
    });
    setTimeout(() => {
      this.weekMonthItems.forEach((element, index) => {
        if (element.nativeElement.textContent.trim() === Monthweek) {
          element.nativeElement.scrollIntoView({
            behavior: 'smooth',
            block: 'nearest'
          });
        }
      });
    });
    setTimeout(() => {
      this.monthMonthItems.forEach((element, index) => {
        if (element.nativeElement.textContent.trim() === Monthmonth) {
          element.nativeElement.scrollIntoView({
            behavior: 'smooth',
            block: 'nearest'
          });
        }
      });
    });
  }
  scrollToSelectedDay() {
    const hourModelDate = new Date(this.dateRangeModel.hourModel.startingDate);
    const selectedDayHour = hourModelDate.getDate().toString();
    const dayModelDate = new Date(this.dateRangeModel.dayModel.startingDate);
    const selectedDayDay = dayModelDate.getDate().toString();
    const weekModelDate = new Date(this.dateRangeModel.weekModel.startingDate);
    const selectedDayweek = weekModelDate.getDate().toString();

    setTimeout(() => {
      this.hourDayItems.forEach((element) => {
        if (element.nativeElement.textContent.trim() === selectedDayHour) {
          element.nativeElement.scrollIntoView({
            behavior: 'smooth',
            block: 'nearest'
          });
        }
      });
    });
    setTimeout(() => {
      this.dayDayItems.forEach((element) => {
        if (element.nativeElement.textContent.trim() === selectedDayDay) {
          element.nativeElement.scrollIntoView({
            behavior: 'smooth',
            block: 'nearest'
          });
        }
      });
    });
    setTimeout(() => {
      this.weekDayItems.forEach((element) => {
        if (element.nativeElement.textContent.trim() === selectedDayweek) {
          element.nativeElement.scrollIntoView({
            behavior: 'smooth',
            block: 'nearest'
          });
        }
      });
    });
  }

  scrollToSelectedYear() {
    const startingDatehour = new Date(
      this.dateRangeModel.hourModel.startingDate
    );
    const hourYear = startingDatehour.getFullYear().toString();
    const startingDateDay = new Date(this.dateRangeModel.dayModel.startingDate);
    const DayYear = startingDateDay.getFullYear().toString();
    const startingDateWeek = new Date(
      this.dateRangeModel.weekModel.startingDate
    );
    const WeekYear = startingDateWeek.getFullYear().toString();
    const startingDateMonth = new Date(
      this.dateRangeModel.monthModel.startingDate
    );
    const monthYear = startingDateMonth.getFullYear().toString();
    const startingDatequarter = new Date(
      this.dateRangeModel.quarterModel.startingDate
    );
    const quaterYear = startingDatequarter.getFullYear().toString();
    const startingDateYear = new Date(
      this.dateRangeModel.yearModel.startingDate
    );
    const yearYear = startingDateYear.getFullYear().toString();

    setTimeout(() => {
      this.hourYearItems.forEach((element) => {
        if (element.nativeElement.textContent.trim() === hourYear) {
          element.nativeElement.scrollIntoView({
            behavior: 'smooth',
            block: 'nearest'
          });
        }
      });
    });
    setTimeout(() => {
      this.dayYearItems.forEach((element) => {
        if (element.nativeElement.textContent.trim() === DayYear) {
          element.nativeElement.scrollIntoView({
            behavior: 'smooth',
            block: 'nearest'
          });
        }
      });
      setTimeout(() => {
        this.weekYearItems.forEach((element) => {
          if (element.nativeElement.textContent.trim() === WeekYear) {
            element.nativeElement.scrollIntoView({
              behavior: 'smooth',
              block: 'nearest'
            });
          }
        });
      });
      setTimeout(() => {
        this.monthYearItems.forEach((element) => {
          if (element.nativeElement.textContent.trim() === monthYear) {
            element.nativeElement.scrollIntoView({
              behavior: 'smooth',
              block: 'nearest'
            });
          }
        });
      });
      setTimeout(() => {
        this.yearQuarterItems.forEach((element) => {
          if (element.nativeElement.textContent.trim() === quaterYear) {
            element.nativeElement.scrollIntoView({
              behavior: 'smooth',
              block: 'nearest'
            });
          }
        });
      });
    });
    setTimeout(() => {
      this.yearYearItems.forEach((element) => {
        if (element.nativeElement.textContent.trim() === yearYear) {
          element.nativeElement.scrollIntoView({
            behavior: 'smooth',
            block: 'nearest'
          });
        }
      });
    });
  }

  scrollToSelectedHour() {
    const startingDate = new Date(this.dateRangeModel.hourModel.startingDate);
    let selectedHour = startingDate.getHours().toString().padStart(2, '0');
    if (Number(selectedHour) > 12) {
      selectedHour = String(Number(selectedHour) - 12);
    }

    setTimeout(() => {
      this.hourHourItems.forEach((element) => {
        if (element.nativeElement.textContent.trim() === selectedHour) {
          element.nativeElement.scrollIntoView({
            behavior: 'smooth',
            block: 'nearest'
          });
        }
      });
    });
  }

  @HostListener('document:click', ['$event'])
  handleClickOutside(event: MouseEvent) {
    // Check if the click target is within the specific area and outside the dropdown
    if (!this.isDatePickerOpen) {
      if (
        this.isDropdownOpen &&
        this.dropdownMenu &&
        !this.dropdownMenu.nativeElement.contains(event.target)
      ) {
        this.isDropdownOpen = false; // Close the dropdown
      }
    }
  }

  // Set the flag to true when the date range picker is opened
  onDateRangePickerOpened(): void {
    this.isDatePickerOpen = true;
  }

  // Set the flag to false when the date range picker is closed
  onDateRangePickerClosed(): void {
    this.isDatePickerOpen = false;
  }

  getRoutID() {
    this.route.paramMap.subscribe((params) => {
      let dateID = params.get('dateID');
      let toDate = params.get('toDate');
      if (dateID && toDate) {
        this.sateDates(Number(dateID), toDate);
      }
    });
  }
  sateDates(id: number, date: string) {
    if (id == 1) {
      this.toDate = moment().format('MMM D YYYY, h:mm A');
      this.fromDate = moment(date)
        .subtract(6, 'day')
        .format('MMM D YYYY, h:mm A');
    } else if (id == 2) {
      this.toDate = moment().format('MMM D YYYY, h:mm A');
      this.fromDate = moment(date)
        .startOf('week')
        .subtract(6, 'week')
        .format('MMM D YYYY, h:mm A');
    } else if (id == 3) {
      this.toDate = moment().format('MMM D YYYY, h:mm A');
      this.fromDate = moment(date)
        .startOf('month')
        .subtract(6, 'month')
        .format('MMM D YYYY, h:mm A');
    } else {
    }
  }

  preventClosure(event: Event, action: number) {
    if (action === 1) {
      event.stopPropagation();
    }
  }
  populateYears(): void {
    for (let i = 10; i >= 0; i--) {
      this.years.push(moment().subtract(i, 'years').year());
    }
  }
  populateDays(): void {
    let startingDate = this.dateRangeModel.hourModel.startingDate;
    if (this.dateRangeModel.day) {
      startingDate = this.dateRangeModel.dayModel.startingDate;
    } else if (this.dateRangeModel.week) {
      startingDate = this.dateRangeModel.weekModel.startingDate;
    } else if (this.dateRangeModel.month) {
      startingDate = this.dateRangeModel.monthModel.startingDate;
    }
    const currentDate = moment(startingDate);
    const daysInMonth = currentDate.daysInMonth();
    this.days = [];
    for (let i = 1; i <= daysInMonth; i++) {
      this.days.push(i);
    }
  }
  setStartingDate() {
    this.dateRangeModel.hourModel.startingDate = moment().format(
      'YYYY-MM-DD HH:mm:ss'
    );
  }
  selectCategory(category: number): void {
    this.dateRangeModel.all = false;
    this.dateRangeModel.specificDate = false;
    this.dateRangeModel.specificPeriod = false;
    switch (category) {
      case 1:
        this.dateRangeModel.all = true;
        break;

      case 3:
        this.dateRangeModel.specificDate = true;
        this.setFromDtToDt();
        break;
      default:
        this.dateRangeModel.specificPeriod = true;
        break;
    }
  }
  selectPeriodType(category: number): void {
    this.dateRangeModel.hour = false;
    this.dateRangeModel.day = false;
    this.dateRangeModel.week = false;
    this.dateRangeModel.month = false;
    this.dateRangeModel.quarter = false;
    this.dateRangeModel.year = false;
    this.countOfEvent = 1;
    // Use switch statement to set the correct property to true
    switch (category) {
      case 1:
        this.dateRangeModel.hour = true;
        this.dateRangeModel.Measure = 'hour';
        this.setFromDtToDt();
        break;
      case 2:
        this.dateRangeModel.day = true;
        this.dateRangeModel.Measure = 'day';
        this.setFromDtToDt();
        break;
      case 3:
        this.dateRangeModel.week = true;
        this.dateRangeModel.Measure = 'week';
        this.setFromDtToDt();
        break;
      case 4:
        this.dateRangeModel.month = true;
        this.dateRangeModel.Measure = 'month';
        this.setFromDtToDt();
        break;
      case 5:
        this.dateRangeModel.quarter = true;
        this.dateRangeModel.Measure = 'quarter';
        this.setFromDtToDt();
        break;
      case 6:
        this.dateRangeModel.year = true;
        this.dateRangeModel.Measure = 'year';
        this.setFromDtToDt();
        break;
      default:
        this.dateRangeModel.day = true;
        this.dateRangeModel.Measure = 'day';
        this.setFromDtToDt();
        break;
    }
  }
  selectSubPeriodType(category: number): void {
    // Helper function to reset all flags for a given model
    const resetFlags = (model: any) => {
      if ('hourtoDate' in model) {
        model.hourtoDate = false;
        model.previousHour = false;
        model.isNPreviousHour = false;
        model.isnPreviousHourWithDate = false;
      } else if ('daytoDate' in model) {
        model.daytoDate = false;
        model.previousDay = false;
        model.isNPreviousDay = false;
        model.isnPreviousDayWithDate = false;
      } else if ('weektoDate' in model) {
        model.weektoDate = false;
        model.previousWeek = false;
        model.isNPreviousWeek = false;
        model.isnPreviousWeekWithDate = false;
      } else if ('monthtoDate' in model) {
        model.monthtoDate = false;
        model.previousMonth = false;
        model.isNPreviousMonth = false;
        model.isnPreviousMonthWithDate = false;
      } else if ('quartertoDate' in model) {
        model.quartertoDate = false;
        model.previousQuarter = false;
        model.isNPreviousQuarter = false;
        model.isnPreviousQuarterWithDate = false;
      } else if ('yeartoDate' in model) {
        model.yeartoDate = false;
        model.previousYear = false;
        model.isNPreviousYear = false;
        model.isnPreviousYearWithDate = false;
      }
    };

    // Reset all flags and set specific flags based on the selected type and category
    if (this.dateRangeModel.hour) {
      resetFlags(this.dateRangeModel.hourModel);
      switch (category) {
        case 2:
          this.dateRangeModel.hourModel.previousHour = true;

          break;
        case 3:
          this.dateRangeModel.hourModel.isNPreviousHour = true;
          this.countOfEvent = this.dateRangeModel.hourModel.nPreviousHour;

          break;
        case 4:
          this.dateRangeModel.hourModel.isnPreviousHourWithDate = true;
          this.countOfEvent =
            this.dateRangeModel.hourModel.nPreviousPeriodHourWithDate;

          break;
        default:
          this.dateRangeModel.hourModel.hourtoDate = true;

          break;
      }
    } else if (this.dateRangeModel.day) {
      resetFlags(this.dateRangeModel.dayModel);
      switch (category) {
        case 2:
          this.dateRangeModel.dayModel.previousDay = true;
          break;
        case 3:
          this.dateRangeModel.dayModel.isNPreviousDay = true;
          this.countOfEvent = this.dateRangeModel.dayModel.nPreviousDay;
          break;
        case 4:
          this.dateRangeModel.dayModel.isnPreviousDayWithDate = true;
          this.countOfEvent =
            this.dateRangeModel.dayModel.nPreviousPeriodDayWithDate;
          break;
        default:
          this.dateRangeModel.dayModel.daytoDate = true;
          break;
      }
    } else if (this.dateRangeModel.week) {
      resetFlags(this.dateRangeModel.weekModel);
      switch (category) {
        case 2:
          this.dateRangeModel.weekModel.previousWeek = true;
          break;
        case 3:
          this.dateRangeModel.weekModel.isNPreviousWeek = true;
          this.countOfEvent = this.dateRangeModel.weekModel.nPreviousWeek;
          break;
        case 4:
          this.dateRangeModel.weekModel.isnPreviousWeekWithDate = true;
          this.countOfEvent =
            this.dateRangeModel.weekModel.nPreviousPeriodWeekWithDate;
          break;
        default:
          this.dateRangeModel.weekModel.weektoDate = true;
          break;
      }
    } else if (this.dateRangeModel.month) {
      resetFlags(this.dateRangeModel.monthModel);
      switch (category) {
        case 2:
          this.dateRangeModel.monthModel.previousMonth = true;
          break;
        case 3:
          this.dateRangeModel.monthModel.isNPreviousMonth = true;
          this.countOfEvent = this.dateRangeModel.monthModel.nPreviousMonth;
          break;
        case 4:
          this.dateRangeModel.monthModel.isnPreviousMonthWithDate = true;
          this.countOfEvent =
            this.dateRangeModel.monthModel.nPreviousPeriodMonthWithDate;
          break;
        default:
          this.dateRangeModel.monthModel.monthtoDate = true;
          break;
      }
    } else if (this.dateRangeModel.quarter) {
      resetFlags(this.dateRangeModel.quarterModel);
      switch (category) {
        case 2:
          this.dateRangeModel.quarterModel.previousQuarter = true;
          break;
        case 3:
          this.dateRangeModel.quarterModel.isNPreviousQuarter = true;
          this.countOfEvent = this.dateRangeModel.quarterModel.nPreviousQuarter;
          break;
        case 4:
          this.dateRangeModel.quarterModel.isnPreviousQuarterWithDate = true;
          this.countOfEvent =
            this.dateRangeModel.quarterModel.nPreviousPeriodQuarterWithDate;
          break;
        default:
          this.dateRangeModel.quarterModel.quartertoDate = true;
          break;
      }
    } else if (this.dateRangeModel.year) {
      resetFlags(this.dateRangeModel.yearModel);
      switch (category) {
        case 2:
          this.dateRangeModel.yearModel.previousYear = true;
          break;
        case 3:
          this.dateRangeModel.yearModel.isNPreviousYear = true;
          this.countOfEvent = this.dateRangeModel.yearModel.nPreviousYear;
          break;
        case 4:
          this.dateRangeModel.yearModel.isnPreviousYearWithDate = true;
          this.countOfEvent =
            this.dateRangeModel.yearModel.nPreviousPeriodYearWithDate;
          break;
        default:
          this.dateRangeModel.yearModel.yeartoDate = true;
          break;
      }
    }

    this.setFromDtToDt();
  }

  selectYear(year: number): void {
    if (this.dateRangeModel.hour) {
      const currentDate = moment(this.dateRangeModel.hourModel.startingDate);
      currentDate.year(year);
      this.dateRangeModel.hourModel.startingDate = currentDate.format(
        'YYYY-MM-DD HH:mm:ss'
      );
    } else if (this.dateRangeModel.day) {
      const currentDate = moment(this.dateRangeModel.dayModel.startingDate);
      currentDate.year(year);
      this.dateRangeModel.dayModel.startingDate =
        currentDate.format('YYYY-MM-DD');
    } else if (this.dateRangeModel.week) {
      const currentDate = moment(this.dateRangeModel.weekModel.startingDate);
      currentDate.year(year);
      this.dateRangeModel.weekModel.startingDate =
        currentDate.format('YYYY-MM-DD');
    } else if (this.dateRangeModel.month) {
      const currentDate = moment(this.dateRangeModel.monthModel.startingDate);
      currentDate.year(year);
      this.dateRangeModel.monthModel.startingDate =
        currentDate.format('YYYY-MM-DD');
    } else if (this.dateRangeModel.quarter) {
      const currentDate = moment(this.dateRangeModel.quarterModel.startingDate);
      currentDate.year(year);
      this.dateRangeModel.quarterModel.startingDate =
        currentDate.format('YYYY-MM-DD');
    } else if (this.dateRangeModel.year) {
      const currentDate = moment(this.dateRangeModel.yearModel.startingDate);
      currentDate.year(year);
      this.dateRangeModel.yearModel.startingDate =
        currentDate.format('YYYY-MM-DD');
    }
    this.setFromDtToDt();
  }
  selectMonth(monthIndex: number): void {
    if (this.dateRangeModel.hour) {
      const currentDate = moment(this.dateRangeModel.hourModel.startingDate);
      currentDate.month(monthIndex);
      this.dateRangeModel.hourModel.startingDate = currentDate.format(
        'YYYY-MM-DD HH:mm:ss'
      );
    } else if (this.dateRangeModel.day) {
      const currentDate = moment(this.dateRangeModel.dayModel.startingDate);
      currentDate.month(monthIndex);
      this.dateRangeModel.dayModel.startingDate =
        currentDate.format('YYYY-MM-DD');
    } else if (this.dateRangeModel.week) {
      const currentDate = moment(this.dateRangeModel.weekModel.startingDate);
      currentDate.month(monthIndex);
      this.dateRangeModel.weekModel.startingDate =
        currentDate.format('YYYY-MM-DD');
    } else if (this.dateRangeModel.month) {
      const currentDate = moment(this.dateRangeModel.monthModel.startingDate);
      currentDate.month(monthIndex);
      this.dateRangeModel.monthModel.startingDate =
        currentDate.format('YYYY-MM-DD');
    }

    this.populateDays();
    this.setFromDtToDt();
  }

  selectDay(day: number): void {
    if (this.dateRangeModel.hour) {
      const currentDate = moment(this.dateRangeModel.hourModel.startingDate);
      currentDate.date(day);
      this.dateRangeModel.hourModel.startingDate = currentDate.format(
        'YYYY-MM-DD HH:mm:ss'
      );
    } else if (this.dateRangeModel.day) {
      const currentDate = moment(this.dateRangeModel.dayModel.startingDate);
      currentDate.date(day);
      this.dateRangeModel.dayModel.startingDate =
        currentDate.format('YYYY-MM-DD');
    } else if (this.dateRangeModel.week) {
      const currentDate = moment(this.dateRangeModel.weekModel.startingDate);
      currentDate.date(day);
      this.dateRangeModel.weekModel.startingDate =
        currentDate.format('YYYY-MM-DD');
    } else if (this.dateRangeModel.month) {
    }
    this.setFromDtToDt();
  }
  selectHour(hour: number) {
    const currentDate = moment(this.dateRangeModel.hourModel.startingDate);
    const isPM = currentDate.hour() >= 12;
    if (isPM && hour < 12) {
      hour += 12;
    } else if (!isPM && hour === 12) {
      hour = 0;
    }
    currentDate.hour(hour);
    this.dateRangeModel.hourModel.startingDate = currentDate.format(
      'YYYY-MM-DD HH:mm:ss'
    );

    this.setFromDtToDt();
  }
  selectAmPm(result: string) {
    const currentDate = moment(this.dateRangeModel.hourModel.startingDate);
    let hour = currentDate.hour();

    if (result == 'PM' && hour < 12) {
      hour += 12;
    } else if (result == 'AM' && hour >= 12) {
      hour -= 12;
    }

    currentDate.hour(hour);

    this.dateRangeModel.hourModel.startingDate = currentDate.format(
      'YYYY-MM-DD HH:mm:ss'
    );
    this.setFromDtToDt();
  }

  onQuarterChange(newQuarter: number): void {
    // Add any additional logic you need to handle the change here
  }
  selectQuarter(newQuarterID: number, newQuarter: string): void {
    this.quarter = newQuarter;

    let fromDt = new Date();

    if (newQuarterID === 0) {
      fromDt = new Date(new Date().getFullYear(), 0, 1); // January 1
    } else if (newQuarterID === 1) {
      fromDt = new Date(new Date().getFullYear(), 3, 1); // April 1
    } else if (newQuarterID === 2) {
      fromDt = new Date(new Date().getFullYear(), 6, 1); // July 1
    } else if (newQuarterID === 3) {
      fromDt = new Date(new Date().getFullYear(), 9, 1); // October 1
    }
    this.dateRangeModel.quarterModel.startingDate = fromDt.toString();
    this.setFromDtToDt();
  }

  onButtonClick() {
    if (this.hideSpecifyPeriod) {
      let toDate = this.updateFromDate(this.dateRangeModel.endDate); // Updates `fromDate`
      this.updateToDate(this.dateRangeModel.endDate);

      this.dateRangeModel.fromDate = this.fromDate;
      this.dateRangeModel.toDate = this.toDate;
      this.dateRangeModel.hourModel.startingDate = this.fromDate;

      //  const dateParts = this.dateRangeModel.endDate.split("-").map(Number); // [2024, 12, 28]
      //  const formatedDate = new Date(dateParts[0], dateParts[1] - 1, dateParts[2]);
      this.dateRangeModel.hourModel.isnPreviousHourWithDate = true;
      this.dateRangeModel.hourModel.isNPreviousHour = false;
      this.dateRangeModel.hourModel.nPreviousPeriodHourWithDate = 12;
    }

    // Set the date range model's fromDate and toDate
    this.dateRangeModel.fromDate = this.fromDate;
    this.dateRangeModel.toDate = this.toDate;

    // Emit the selected date range to the parent component
    this.dateRangeSelected.emit(this.dateRangeModel);

    this.isDropdownOpen = false;
  }

  setFromDtToDt() {
    if (this.isTaxReport == false && this.isSummaryReport == false) {
      if (this.dateRangeModel.all) {
      } else if (this.dateRangeModel.specificPeriod) {
        if (this.dateRangeModel.hour) {
          if (this.dateRangeModel.hourModel.hourtoDate) {
            this.fromDate = moment()
              .startOf('hour')
              .format('MMM D YYYY, h:mm A');
            this.toDate = moment().format('MMM D YYYY, h:mm A');
          } else if (this.dateRangeModel.hourModel.previousHour) {
            const now = moment();
            this.toDate = now
              .set({ minute: 0, second: 0, millisecond: 0 })
              .format('MMM D YYYY, h:mm A');
            this.fromDate = now
              .subtract(1, 'hours')
              .set({ minute: 0, second: 0, millisecond: 0 })
              .format('MMM D YYYY, h:mm A');
          } else if (this.dateRangeModel.hourModel.isNPreviousHour) {
            const now = moment();
            this.toDate = now
              .set({ minute: 0, second: 0, millisecond: 0 })
              .format('MMM D YYYY, h:mm A');
            this.fromDate = now
              .subtract(this.dateRangeModel.hourModel.nPreviousHour, 'hours')
              .set({ minute: 0, second: 0, millisecond: 0 })
              .format('MMM D YYYY, h:mm A');
          } else if (this.dateRangeModel.hourModel.isnPreviousHourWithDate) {
            const now = moment(this.dateRangeModel.hourModel.startingDate);
            const hours =
              Number(
                this.dateRangeModel.hourModel.nPreviousPeriodHourWithDate
              ) || 0;
            this.toDate = now
              .clone()
              .set({ minute: 0, second: 0, millisecond: 0 })
              .format('MMM D YYYY, h:mm A');
            this.fromDate = now
              .clone()
              .subtract(hours, 'hours')
              .set({ minute: 0, second: 0, millisecond: 0 })
              .format('MMM D YYYY, h:mm A');
          } else {
          }
        } else if (this.dateRangeModel.day) {
          if (this.dateRangeModel.dayModel.daytoDate) {
            this.fromDate = moment().startOf('day').format('MMM D YYYY');
            this.toDate = moment().format('MMM D YYYY');
          } else if (this.dateRangeModel.dayModel.previousDay) {
            const now = moment();
            const previousDay = now
              .subtract(1, 'day')
              .set({ minute: 0, second: 0, millisecond: 0 });
            this.toDate = previousDay.format('MMM D, YYYY');
            this.fromDate = previousDay.format('MMM D, YYYY');
          } else if (this.dateRangeModel.dayModel.isNPreviousDay) {
            const now = moment();
            this.toDate = now
              .subtract(1, 'day')
              .set({ minute: 0, second: 0, millisecond: 0 })
              .format('MMM D, YYYY');
            this.fromDate = now
              .subtract(this.dateRangeModel.dayModel.nPreviousDay - 1, 'day')
              .set({ minute: 0, second: 0, millisecond: 0 })
              .format('MMM D, YYYY');
          } else if (this.dateRangeModel.dayModel.isnPreviousDayWithDate) {
            const now = moment(this.dateRangeModel.dayModel.startingDate);
            this.fromDate = now
              .set({ minute: 0, second: 0, millisecond: 0 })
              .format('MMM D, YYYY');
            this.toDate = now
              .add(
                this.dateRangeModel.dayModel.nPreviousPeriodDayWithDate - 1,
                'day'
              )
              .set({ minute: 0, second: 0, millisecond: 0 })
              .format('MMM D, YYYY');
          } else {
          }
        } else if (this.dateRangeModel.week) {
          if (this.dateRangeModel.weekModel.weektoDate) {
            const now = moment();
            let nowCopy = moment(); // Use a different variable for clarity
            let sunday = now
              .set({ minute: 0, second: 0, millisecond: 0 })
              .startOf('week');
            if (sunday.isSame(nowCopy, 'day')) {
              sunday = sunday
                .subtract(1, 'day')
                .set({ minute: 0, second: 0, millisecond: 0 })
                .startOf('week');
            }

            this.fromDate = moment(sunday).add(1, 'day').format('MMM D YYYY');
            this.toDate = moment()
              .set({ minute: 0, second: 0, millisecond: 0 })
              .format('MMM D, YYYY');
          } else if (this.dateRangeModel.weekModel.previousWeek) {
            const now = moment();
            let nowCopy = moment(); // Use a different variable for clarity
            let sunday = now
              .set({ minute: 0, second: 0, millisecond: 0 })
              .startOf('week');
            if (sunday.isSame(nowCopy, 'day')) {
              sunday = sunday
                .subtract(1, 'day')
                .set({ minute: 0, second: 0, millisecond: 0 })
                .startOf('week');
            }
            const startOfCurrentWeek = moment(sunday)
              .subtract(1, 'week')
              .startOf('week');
            const endOftpriviousWeek = moment(sunday).startOf('week');
            this.fromDate = moment(startOfCurrentWeek)
              .add(1, 'day')
              .format('MMM D, YYYY');
            this.toDate = endOftpriviousWeek.format('MMM D, YYYY');
          } else if (this.dateRangeModel.weekModel.isNPreviousWeek) {
            const now = moment();
            let nowCopy = moment(); // Use a different variable for clarity
            let sunday = now
              .set({ minute: 0, second: 0, millisecond: 0 })
              .startOf('week');
            if (sunday.isSame(nowCopy, 'day')) {
              sunday = sunday
                .subtract(1, 'day')
                .set({ minute: 0, second: 0, millisecond: 0 })
                .startOf('week');
            }
            const startOfCurrentWeek = moment(sunday)
              .subtract(this.dateRangeModel.weekModel.nPreviousWeek, 'week')
              .startOf('week');
            const endOftpriviousWeek = moment(sunday).startOf('week');
            this.fromDate = moment(startOfCurrentWeek)
              .add(1, 'day')
              .format('MMM D, YYYY');
            this.toDate = endOftpriviousWeek.format('MMM D, YYYY');
          } else if (this.dateRangeModel.weekModel.isnPreviousWeekWithDate) {
            const now = moment(this.dateRangeModel.weekModel.startingDate);
            let nowCopy = moment(this.dateRangeModel.weekModel.startingDate); // Use a different variable for clarity
            let sunday = now
              .set({ minute: 0, second: 0, millisecond: 0 })
              .startOf('week');
            if (sunday.isSame(nowCopy, 'day')) {
              sunday = sunday
                .subtract(1, 'day')
                .set({ minute: 0, second: 0, millisecond: 0 })
                .startOf('week');
            }

            this.fromDate = sunday.add(1, 'day').format('MMM D, YYYY');
            this.toDate = sunday
              .add(
                this.dateRangeModel.weekModel.nPreviousPeriodWeekWithDate * 7 -
                  1,
                'days'
              )
              .set({ minute: 0, second: 0, millisecond: 0 })
              .format('MMM D, YYYY');
          } else {
          }
        } else if (this.dateRangeModel.month) {
          if (this.dateRangeModel.monthModel.monthtoDate) {
            this.fromDate = moment().startOf('month').format('MMM D YYYY');
            this.toDate = moment().format('MMM D, YYYY');
          } else if (this.dateRangeModel.monthModel.previousMonth) {
            const now = moment();
            const startOfCurrentMonth = moment(now).startOf('month');
            const startOfPreviousMonth = moment(startOfCurrentMonth).subtract(
              1,
              'month'
            );
            const endOfPreviousMonth = moment(startOfCurrentMonth).subtract(
              1,
              'day'
            );
            this.fromDate = startOfPreviousMonth.format('MMM D, YYYY');
            this.toDate = endOfPreviousMonth.format('MMM D, YYYY');
          } else if (this.dateRangeModel.monthModel.isNPreviousMonth) {
            const now = moment();
            const startOfCurrentMonth = moment(now).startOf('month');
            const startOfPreviousMonth = moment(startOfCurrentMonth).subtract(
              this.dateRangeModel.monthModel.nPreviousMonth,
              'month'
            );
            const endOfPreviousMonth = moment(startOfCurrentMonth).subtract(
              1,
              'day'
            );
            this.fromDate = startOfPreviousMonth.format('MMM D, YYYY');
            this.toDate = endOfPreviousMonth.format('MMM D, YYYY');
          } else if (this.dateRangeModel.monthModel.isnPreviousMonthWithDate) {
            const now = moment(this.dateRangeModel.monthModel.startingDate);
            const startOfCurrentMonth = moment(now).startOf('month');
            const endOfPreviousMonth = moment(startOfCurrentMonth).subtract(
              1,
              'day'
            );
            this.fromDate = startOfCurrentMonth
              .set({ minute: 0, second: 0, millisecond: 0 })
              .format('MMM D, YYYY');
            this.toDate = endOfPreviousMonth
              .add(
                this.dateRangeModel.monthModel.nPreviousPeriodMonthWithDate,
                'month'
              )
              .endOf('month')
              .set({ minute: 0, second: 0, millisecond: 0 })
              .format('MMM D, YYYY');
          }
        } else if (this.dateRangeModel.quarter) {
          if (this.dateRangeModel.quarterModel.quartertoDate) {
            this.fromDate = moment().startOf('quarter').format('MMM D YYYY');
            this.toDate = moment().format('MMM D, YYYY');
          } else if (this.dateRangeModel.quarterModel.previousQuarter) {
            const now = moment();
            const startOfCurrentQuarter = now.startOf('quarter');
            const endOfCurrentQuarter = now.startOf('quarter');
            this.toDate = startOfCurrentQuarter
              .subtract(1, 'day')
              .format('MMM D, YYYY');
            const endOfPreviousQuarter = endOfCurrentQuarter.subtract(1, 'day');
            const fromDateQuarter = endOfPreviousQuarter.startOf('quarter');
            this.fromDate = fromDateQuarter.format('MMM D, YYYY');
          } else if (this.dateRangeModel.quarterModel.isNPreviousQuarter) {
            const now = moment();
            const startOfCurrentQuarter = now.startOf('quarter').clone();
            const endOfPreviousQuarter = now
              .startOf('quarter')
              .clone()
              .subtract(1, 'day');
            this.toDate = endOfPreviousQuarter.format('MMM D, YYYY');
            const threeMonthsAgo = startOfCurrentQuarter
              .clone()
              .subtract(
                this.dateRangeModel.quarterModel.nPreviousQuarter,
                'quarter'
              );
            const fromDateQuarter = threeMonthsAgo.startOf('quarter').clone();
            this.fromDate = fromDateQuarter.format('MMM D, YYYY');
          } else if (
            this.dateRangeModel.quarterModel.isnPreviousQuarterWithDate
          ) {
            const now = moment(
              this.dateRangeModel.quarterModel.startingDate
            ).startOf('quarter');
            this.fromDate = now.clone().format('MMM D, YYYY');
            const now1 = now
              .add(
                this.dateRangeModel.quarterModel.nPreviousPeriodQuarterWithDate,
                'quarter'
              )
              .clone();
            this.toDate = now1.subtract(1, 'day').format('MMM D, YYYY');
          } else {
          }
        } else if (this.dateRangeModel.year) {
          if (this.dateRangeModel.yearModel.yeartoDate) {
            this.fromDate = moment().startOf('year').format('MMM D YYYY');
            this.toDate = moment().format('MMM D, YYYY');
          } else if (this.dateRangeModel.yearModel.previousYear) {
            const now = moment();
            const startOfCurrentYear = now.startOf('year');
            const endOfPreviousQuarter = startOfCurrentYear.subtract(1, 'day');
            this.toDate = endOfPreviousQuarter.format('MMM D, YYYY');
            const threeMonthsAgo = endOfPreviousQuarter.subtract(1, 'months');
            const fromDateQuarter = threeMonthsAgo.startOf('year');
            this.fromDate = fromDateQuarter.format('MMM D, YYYY');
          } else if (this.dateRangeModel.yearModel.isNPreviousYear) {
            const now = moment();
            const now2 = moment();
            const startOfCurrentYear = now.startOf('year');
            const endOfPreviousYear = startOfCurrentYear.subtract(1, 'day');
            this.toDate = endOfPreviousYear.format('MMM D, YYYY');
            const previousYear = now2.subtract(
              this.dateRangeModel.yearModel.nPreviousYear,
              'years'
            );
            const startOfPreviousYear = previousYear.startOf('year');
            this.fromDate = startOfPreviousYear.format('MMM D, YYYY');
          } else if (this.dateRangeModel.yearModel.isnPreviousYearWithDate) {
            const now = moment(this.dateRangeModel.yearModel.startingDate);
            const now2 = moment(this.dateRangeModel.yearModel.startingDate);
            const startYear = now.startOf('year');
            this.fromDate = startYear.format('MMM D, YYYY');
            const nYear = now2.add(
              this.dateRangeModel.yearModel.nPreviousPeriodYearWithDate - 1,
              'years'
            );
            const startOfPreviousYear = nYear.endOf('year');
            this.toDate = startOfPreviousYear.format('MMM D, YYYY');
          } else {
          }
        }
      } else if (this.dateRangeModel.specificDate) {
      } else {
      }
    }

    if (this.isTaxReport == true || this.isSummaryReport == true) {
      if (this.dateRangeModel.all) {
      } else if (this.dateRangeModel.specificPeriod) {
        if (this.dateRangeModel.hour) {
          if (this.dateRangeModel.hourModel.hourtoDate) {
            this.fromDate = moment()
              .startOf('hour')
              .format('MMM D YYYY, h:mm A');
            this.toDate = moment().format('MMM D YYYY, h:mm: A');
            this.toDate = this.fromDate;
          } else if (this.dateRangeModel.hourModel.previousHour) {
            const now = moment();
            this.toDate = now
              .subtract(1, 'hours')
              .set({ minute: 0, second: 0, millisecond: 0 })
              .format('MMM D YYYY, h:mm A');
            //this.fromDate = now.subtract(1, 'hours').set({ minute: 0, second: 0, millisecond: 0 }).format('MMM D YYYY, h:mm A');
            this.fromDate = this.toDate;
          } else if (this.dateRangeModel.hourModel.isNPreviousHour) {
            const now = moment();
            //this.toDate = now.set({ minute: 0, second: 0, millisecond: 0 }).format('MMM D YYYY, h:mm A');
            this.toDate = now
              .subtract(1, 'hours')
              .set({ minute: 0, second: 0, millisecond: 0 })
              .format('MMM D YYYY, h:mm A');
            this.fromDate = now
              .subtract(this.countOfEvent - 1, 'hours')
              .set({ minute: 0, second: 0, millisecond: 0 })
              .format('MMM D YYYY, h:mm A');
          } else if (this.dateRangeModel.hourModel.isnPreviousHourWithDate) {
            const now = moment(this.dateRangeModel.hourModel.startingDate);
            const hours =
              Number(this.countOfEvent) ||
              Number(
                this.dateRangeModel.hourModel.nPreviousPeriodHourWithDate
              ) ||
              1;
            this.toDate = now
              .clone()
              .set({ minute: 0, second: 0, millisecond: 0 })
              .format('MMM D YYYY, h:mm A');
            this.fromDate = now
              .clone()
              .subtract(hours, 'hours')
              .set({ minute: 0, second: 0, millisecond: 0 })
              .format('MMM D YYYY, h:mm A');
          } else {
          }
        } else if (this.dateRangeModel.day) {
          if (this.dateRangeModel.dayModel.daytoDate) {
            this.fromDate = moment().startOf('day').format('MMM D YYYY');
            this.toDate = moment().format('MMM D YYYY');
          } else if (this.dateRangeModel.dayModel.previousDay) {
            const now = moment();
            this.toDate = now
              .subtract(1, 'day')
              .set({ minute: 0, second: 0, millisecond: 0 })
              .format('MMM D, YYYY');
            //this.fromDate = now.subtract(1, 'day').set({ minute: 0, second: 0, millisecond: 0 }).format('MMM D, YYYY');
            this.fromDate = this.toDate;
          } else if (this.dateRangeModel.dayModel.isNPreviousDay) {
            const now = moment();
            //this.toDate = now.set({ minute: 0, second: 0, millisecond: 0 }).format('MMM D, YYYY');
            this.toDate = now
              .subtract(1, 'day')
              .set({ minute: 0, second: 0, millisecond: 0 })
              .format('MMM D, YYYY');
            this.fromDate = now
              .subtract(this.countOfEvent - 1, 'days')
              .set({ minute: 0, second: 0, millisecond: 0 })
              .format('MMM D, YYYY');
          } else if (this.dateRangeModel.dayModel.isnPreviousDayWithDate) {
            const now = moment(this.dateRangeModel.dayModel.startingDate);
            this.fromDate = now
              .set({ minute: 0, second: 0, millisecond: 0 })
              .format('MMM D, YYYY');
            // this.toDate = now.add(this.dateRangeModel.dayModel.nPreviousPeriodDayWithDate, 'day').set({ minute: 0, second: 0, millisecond: 0 }).format('MMM D, YYYY');
            this.toDate = now
              .add(this.countOfEvent - 1, 'day')
              .set({ minute: 0, second: 0, millisecond: 0 })
              .format('MMM D, YYYY');
          } else {
          }
        } else if (this.dateRangeModel.week) {
          if (this.dateRangeModel.weekModel.weektoDate) {
            this.countOfEvent = 1;
            const now = moment();
            let nowCopy = moment(); // Use a different variable for clarity
            let sunday = now
              .set({ minute: 0, second: 0, millisecond: 0 })
              .startOf('week');
            if (sunday.isSame(nowCopy, 'day')) {
              sunday = sunday
                .subtract(1, 'day')
                .set({ minute: 0, second: 0, millisecond: 0 })
                .startOf('week');
            }

            this.fromDate = moment(sunday).add(1, 'day').format('MMM D YYYY');
            this.toDate = moment()
              .set({ minute: 0, second: 0, millisecond: 0 })
              .format('MMM D, YYYY');
          } else if (this.dateRangeModel.weekModel.previousWeek) {
            this.countOfEvent = 1;
            const now = moment();
            let nowCopy = moment(); // Use a different variable for clarity
            let sunday = now
              .set({ minute: 0, second: 0, millisecond: 0 })
              .startOf('week');
            if (sunday.isSame(nowCopy, 'day')) {
              sunday = sunday
                .subtract(1, 'day')
                .set({ minute: 0, second: 0, millisecond: 0 })
                .startOf('week');
            }
            const startOfCurrentWeek = moment(sunday)
              .subtract(1, 'week')
              .startOf('week');
            const endOftpriviousWeek = moment(sunday).startOf('week');
            this.fromDate = moment(startOfCurrentWeek)
              .add(1, 'day')
              .format('MMM D, YYYY');
            this.toDate = moment(endOftpriviousWeek)
              .add(1, 'day')
              .format('MMM D, YYYY');
            // this.toDate = endOftpriviousWeek.format('MMM D, YYYY');
          } else if (this.dateRangeModel.weekModel.isNPreviousWeek) {
            const now = moment();
            let nowCopy = moment(); // Use a different variable for clarity
            let sunday = now
              .set({ minute: 0, second: 0, millisecond: 0 })
              .startOf('week');
            if (sunday.isSame(nowCopy, 'day')) {
              sunday = sunday
                .subtract(1, 'day')
                .set({ minute: 0, second: 0, millisecond: 0 })
                .startOf('week');
            }
            //const startOfCurrentWeek = moment(sunday).subtract(this.dateRangeModel.weekModel.nPreviousWeek, 'week').startOf('week');
            const startOfCurrentWeek = moment(sunday)
              .subtract(this.countOfEvent - 1, 'week')
              .startOf('week');
            const endOftpriviousWeek = moment(sunday).startOf('week');
            this.fromDate = moment(startOfCurrentWeek)
              .add(1, 'day')
              .format('MMM D, YYYY');
            this.toDate = moment(endOftpriviousWeek)
              .add(1, 'day')
              .format('MMM D, YYYY');
            //this.toDate = endOftpriviousWeek.format('MMM D, YYYY');
          } else if (this.dateRangeModel.weekModel.isnPreviousWeekWithDate) {
            const now = moment(this.dateRangeModel.weekModel.startingDate);
            let nowCopy = moment(this.dateRangeModel.weekModel.startingDate); // Use a different variable for clarity
            let sunday = now
              .set({ minute: 0, second: 0, millisecond: 0 })
              .startOf('week');
            if (sunday.isSame(nowCopy, 'day')) {
              sunday = sunday
                .subtract(1, 'day')
                .set({ minute: 0, second: 0, millisecond: 0 })
                .startOf('week');
            }

            this.fromDate = sunday.add(1, 'day').format('MMM D, YYYY');
            // this.toDate = sunday.add(this.dateRangeModel.weekModel.nPreviousPeriodWeekWithDate * 7-1, 'days').set({ minute: 0, second: 0, millisecond: 0 }).format('MMM D, YYYY');
            this.toDate = sunday
              .add((this.countOfEvent - 1) * 7, 'days')
              .set({ minute: 0, second: 0, millisecond: 0 })
              .format('MMM D, YYYY');
            if (this.countOfEvent == 1) {
              this.toDate = this.fromDate;
            }
            // this.fromDate =  moment(this.fromDate).subtract(1, 'day').format('MMM D, YYYY');
          } else {
          }
        } else if (this.dateRangeModel.month) {
          if (this.dateRangeModel.monthModel.monthtoDate) {
            this.fromDate = moment().startOf('month').format('MMM D YYYY');
            this.toDate = moment().endOf('month').format('MMM D YYYY');
            this.fromDate = this.fromDate;
            this.toDate = moment().format('MMM D YYYY, h:mm A');
          } else if (this.dateRangeModel.monthModel.previousMonth) {
            const now = moment();
            const startOfCurrentMonth = moment(now).startOf('month');
            const startOfPreviousMonth = moment(startOfCurrentMonth).subtract(
              1,
              'month'
            );
            const endOfPreviousMonth = moment(startOfCurrentMonth).subtract(
              1,
              'day'
            );
            this.fromDate = startOfPreviousMonth.format('MMM D, YYYY');
            this.toDate = endOfPreviousMonth.format('MMM D, YYYY');
          } else if (this.dateRangeModel.monthModel.isNPreviousMonth) {
            const now = moment();
            const startOfCurrentMonth = moment(now).startOf('month');
            // const startOfPreviousMonth = moment(startOfCurrentMonth).subtract(this.dateRangeModel.monthModel.nPreviousMonth, 'month');
            const startOfPreviousMonth = moment(startOfCurrentMonth).subtract(
              this.countOfEvent,
              'month'
            );
            const endOfPreviousMonth = moment(startOfCurrentMonth).subtract(
              1,
              'day'
            );
            this.fromDate = startOfPreviousMonth.format('MMM D, YYYY');
            this.toDate = endOfPreviousMonth.format('MMM D, YYYY');

            // if(this.countOfEvent ==1){
            //   const startOfPreviousMonth = moment(startOfCurrentMonth).subtract((this.countOfEvent -1), 'month');
            //   this.toDate = endOfPreviousMonth.format('MMM D, YYYY');
            // }
          } else if (this.dateRangeModel.monthModel.isnPreviousMonthWithDate) {
            const now = moment(this.dateRangeModel.monthModel.startingDate);
            const startOfCurrentMonth = moment(now).startOf('month');
            const endOfCurrentMonth = moment(now).endOf('month');
            const endOfPreviousMonth = moment(startOfCurrentMonth).subtract(
              1,
              'day'
            );
            this.fromDate = startOfCurrentMonth
              .set({ minute: 0, second: 0, millisecond: 0 })
              .format('MMM D, YYYY');
            // this.toDate = endOfPreviousMonth.add(this.dateRangeModel.monthModel.nPreviousPeriodMonthWithDate, 'month').endOf('month').set({ minute: 0, second: 0, millisecond: 0 }).format('MMM D, YYYY');
            if (this.countOfEvent == 1) {
            }
            this.toDate = endOfCurrentMonth
              .add(this.countOfEvent - 1, 'month')
              .endOf('month')
              .set({ minute: 0, second: 0, millisecond: 0 })
              .format('MMM D, YYYY');
            //this.toDate =
          }
        } else if (this.dateRangeModel.quarter) {
          if (this.dateRangeModel.quarterModel.quartertoDate) {
            this.fromDate = moment().startOf('quarter').format('MMM D YYYY');
            this.toDate = moment().format('MMM D, YYYY');
          } else if (this.dateRangeModel.quarterModel.previousQuarter) {
            const now = moment();
            const startOfCurrentQuarter = now.startOf('quarter');
            const endOfCurrentQuarter = now.startOf('quarter');
            this.toDate = startOfCurrentQuarter
              .subtract(1, 'day')
              .format('MMM D, YYYY');
            const endOfPreviousQuarter = endOfCurrentQuarter.subtract(1, 'day');
            const fromDateQuarter = endOfPreviousQuarter.startOf('quarter');
            this.fromDate = fromDateQuarter.format('MMM D, YYYY');
          } else if (this.dateRangeModel.quarterModel.isNPreviousQuarter) {
            const now = moment();
            const startOfCurrentQuarter = now.startOf('quarter').clone();
            const endOfPreviousQuarter = now
              .startOf('quarter')
              .clone()
              .subtract(1, 'day');
            this.toDate = endOfPreviousQuarter.format('MMM D, YYYY');
            // const threeMonthsAgo = startOfCurrentQuarter.clone().subtract(this.dateRangeModel.quarterModel.nPreviousQuarter, 'quarter');
            const threeMonthsAgo = startOfCurrentQuarter
              .clone()
              .subtract(this.countOfEvent - 1, 'quarter');
            const fromDateQuarter = threeMonthsAgo.startOf('quarter').clone();

            this.fromDate = fromDateQuarter.format('MMM D, YYYY');
            if (this.countOfEvent == 1) {
              this.fromDate = this.toDate;
            }
          } else if (
            this.dateRangeModel.quarterModel.isnPreviousQuarterWithDate
          ) {
            const now = moment(
              this.dateRangeModel.quarterModel.startingDate
            ).startOf('quarter');
            this.fromDate = now.clone().format('MMM D, YYYY');
            // const now1 = now.add(this.dateRangeModel.quarterModel.nPreviousPeriodQuarterWithDate, 'quarter').clone();
            const now1 = now.add(this.countOfEvent - 1, 'quarter').clone();
            this.toDate = now1.subtract(1, 'day').format('MMM D, YYYY');

            if (this.countOfEvent == 1) {
              this.fromDate = this.toDate;
            }
          } else {
          }
        } else if (this.dateRangeModel.year) {
          if (this.dateRangeModel.yearModel.yeartoDate) {
            this.fromDate = moment().startOf('year').format('MMM D YYYY');
            this.toDate = moment().format('MMM D, YYYY');
          } else if (this.dateRangeModel.yearModel.previousYear) {
            const now = moment();
            const startOfCurrentYear = now.startOf('year');
            const endOfPreviousQuarter = startOfCurrentYear.subtract(1, 'day');
            this.toDate = endOfPreviousQuarter.format('MMM D, YYYY');
            const threeMonthsAgo = endOfPreviousQuarter.subtract(1, 'months');
            const fromDateQuarter = threeMonthsAgo.startOf('year');
            this.fromDate = fromDateQuarter.format('MMM D, YYYY');
          } else if (this.dateRangeModel.yearModel.isNPreviousYear) {
            const now = moment();
            const now2 = moment();
            const startOfCurrentYear = now.startOf('year');
            const endOfPreviousYear = startOfCurrentYear.subtract(1, 'day');
            this.toDate = endOfPreviousYear.format('MMM D, YYYY');
            // const previousYear = now2.subtract(this.dateRangeModel.yearModel.nPreviousYear, 'years');
            const previousYear = now2.subtract(this.countOfEvent, 'years');
            const startOfPreviousYear = previousYear.startOf('year');
            this.fromDate = startOfPreviousYear.format('MMM D, YYYY');
          } else if (this.dateRangeModel.yearModel.isnPreviousYearWithDate) {
            const now = moment(this.dateRangeModel.yearModel.startingDate);
            const now2 = moment(this.dateRangeModel.yearModel.startingDate);
            const startYear = now.startOf('year');
            this.fromDate = startYear.format('MMM D, YYYY');
            //const nYear = now2.add(this.dateRangeModel.yearModel.nPreviousPeriodYearWithDate-1, 'years');
            const nYear = now2.add(this.countOfEvent - 1, 'years');
            const startOfPreviousYear = nYear.endOf('year');
            this.toDate = startOfPreviousYear.format('MMM D, YYYY');
          } else {
          }
        }
      } else if (this.dateRangeModel.specificDate) {
      } else {
      }
    }
  }
  calculateMonths(): boolean {
    const fromDate = new Date(this.fromDate);
    const toDate = new Date(this.toDate);
    const monthsDiff =
      (toDate.getFullYear() - fromDate.getFullYear()) * 12 +
      (toDate.getMonth() - fromDate.getMonth());
    return monthsDiff > 25;
  }

  checkRange(newQuarter: any) {
    const newQuarterStr = newQuarter.toString();
    this.countOfEvent = 0;
    this.countOfEvent = newQuarter;
    //  this.countOfEvent = (this.countOfEvent - 1)
    //NoOfDays = parseInt(NoOfDays, 10);
    if (newQuarterStr != '') {
      // Check if the newQuarter contains any special characters or alphabets
      const isValid = /^[0-9]+$/.test(newQuarterStr); // Regex to allow only numbers

      // Assign null if invalid
      if (isValid == false) {
        const result = isValid ? newQuarterStr : null;
        newQuarter = result;
        this.dateRangeModel = new DateRangeModel();
        this.dateRangeModel.dayModel.nPreviousDay = 1;
        this.dateRangeModel.hourModel.nPreviousHour = 1;
        this.dateRangeModel.weekModel.nPreviousWeek = 1;
        this.dateRangeModel.quarterModel.nPreviousQuarter = 1;
        this.dateRangeModel.monthModel.nPreviousMonth = 1;
        this.dateRangeModel.yearModel.nPreviousYear = 1;
        this.dateRangeModel.yearModel.nPreviousPeriodYearWithDate = 1;
        this.dateRangeModel.hourModel.nPreviousPeriodHourWithDate = 1;
        this.dateRangeModel.dayModel.nPreviousPeriodDayWithDate = 1;
        this.dateRangeModel.weekModel.nPreviousPeriodWeekWithDate = 1;
        this.dateRangeModel.monthModel.nPreviousPeriodMonthWithDate = 1;
        this.dateRangeModel.quarterModel.nPreviousPeriodQuarterWithDate = 1;
        this.toastr.error('Please enter valid entry');
      }
    }
    this.isTaxReport;

    this.setFromDtToDt();
  }
  getQuarter() {
    const month = new Date().getMonth();
    let noOfQuater = Math.floor(month / 3);
    this.quarter = this.quarters[noOfQuater];
  }

  getSaleByHoursOfDay() {
    if (this.hoursOfDay) {
      this.hoursOfDay.nativeElement.click();
    }
    this.selectSubPeriodType(3);
    const currentDate = new Date();

    // Get the current hour (returns 0-23, where 0 is midnight and 23 is 11 PM)
    const currentHour = currentDate.getHours();
    this.dateRangeModel.hourModel.nPreviousHour = currentHour;
    this.checkRange(currentHour);
    this.onButtonClick();
  }

  updateFromDate(selectedDate: string): void {
    // Parse the selected date (e.g., "2024-12-28")
    const dateParts = selectedDate.split('-').map(Number); // [2024, 12, 28]
    const date = new Date(dateParts[0], dateParts[1] - 1, dateParts[2]);

    // Format the date
    this.fromDate = date.toLocaleString('en-US', {
      month: 'short',
      day: 'numeric',
      year: 'numeric',
      hour: 'numeric',
      minute: 'numeric',
      hour12: true
    });
  }

  updateToDate(selectedDate: string): void {
    // Split the input date string (expected format: "YYYY-MM-DD")
    const dateParts = selectedDate.split('-').map(Number); // Example: [2024, 12, 28]

    // Ensure the dateParts array has valid components
    if (dateParts.length === 3) {
      // Create a Date object with the specified year, month, and day
      const date = new Date(dateParts[0], dateParts[1] - 1, dateParts[2]);

      // Set the time to 12:00 PM
      date.setHours(12, 0, 0, 0);

      // Format the date into the desired string format
      this.toDate = date.toLocaleString('en-US', {
        month: 'short',
        day: 'numeric',
        year: 'numeric',
        hour: 'numeric',
        minute: 'numeric',
        hour12: true
      });
    } else {
      console.error('Invalid date format. Expected format: YYYY-MM-DD');
    }
  }

  onStartDateSelected(event: any) {
    this.dateRangeModel.startDate;
    this.dateRangeModel.Measure = 'custom';
    const now = moment(this.dateRangeModel.startDate);
    const fromDate = new Date(this.dateRangeModel.startDate);
    this.fromDate = now.format('MMM D, YYYY');
    //this.fromDate = fromDate;
  }
  onEndDateSelected(event: any) {
    this.dateRangeModel.endDate;
    this.dateRangeModel.Measure = 'custom';
    const now = moment(this.dateRangeModel.endDate);
    this.toDate = now.format('MMM D, YYYY');

    this.dateRangeModel.isDateRangeSelected = true;
  }
}
